import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
        };
        return requestOptions
    }

}
// api
export const teleconsultListingApi = async ({ length, sort, page, name, date, status, sort_order }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}teleconsultation?sort_order=${sort_order}&sort=${sort}&size=${length}&paginate=${page}&search=${name}&status=${status}&appointment_at=${date}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(["No data"]);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const teleconsultDetailsApi = async ({ id }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}teleconsultation/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(data);
                    }
                } else {
                    reject(data);

                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addNewTeleconsult = async (teleconsult) => {
    const request = requestAuthOption("POST", teleconsult)
    try {
        const response = await fetch(`${server}teleconsultation`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const delTeleconsult = async ({ id, msg }) => {
    const request = requestAuthOption("DELETE", msg)

    try {
        const response = await fetch(`${server}teleconsultation/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const updateTeleconsult = async ({ id, teleconsult }) => {
    const request = requestAuthOption("PUT", teleconsult)
    try {
        const response = await fetch(`${server}teleconsultation/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve([data]);
                    } else if (data.code === "invalid_field") {
                        reject(data);
                    } else if (data.code === "invalid_input") {
                        reject(data);
                    } else {
                        reject([data]);
                    }
                } else {
                    reject(data);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const confirmTeleconsult = async ({ id, teleconsult }) => {
    const request = requestAuthOption("PUT", teleconsult)
    try {
        const response = await fetch(`${server}teleconsultation/confirmed/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const completeTeleconsult = async ({ id, teleconsult }) => {
    const request = requestAuthOption("PUT", teleconsult)
    try {
        const response = await fetch(`${server}teleconsultation/completed/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addRemarksTeleAppointment = async (payload) => {
    const request = requestAuthOption("PUT", payload?.teleconsult)
    try {
        const response = await fetch(`${server}teleconsultation/${payload?.id}/remark`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};